import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";

const LoanDetailsDialog = ({
  open,
  onClose,
  loans = [],
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Existing Loan Details</DialogTitle>

      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><b>Loan Account No.</b></TableCell>
              <TableCell align="right"><b>Principal Amount</b></TableCell>
              <TableCell align="right"><b>Outstanding Interest</b></TableCell>
              <TableCell align="right"><b>Outstanding Charges</b></TableCell>
              <TableCell align="right"><b>Future Interest</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loans.length > 0 ? (
              loans.map((loan, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {loan.loanAccountNumber || "-"}
                  </TableCell>

                  <TableCell align="right">
                    {(
                      Number(loan.principalAmount || 0)
                    ).toLocaleString("en-IN")}
                  </TableCell>
                  <TableCell align="right">
                    {(
                      Number(loan.outstandingInterest || 0)
                    ).toLocaleString("en-IN")}
                  </TableCell>
                  <TableCell align="right">
                    {(
                      Number(loan?.outstandingCharges || 0)
                    ).toLocaleString("en-IN")}
                  </TableCell>

                  <TableCell align="right">
                    {Number(
                      loan.futureInterest || 0
                    ).toLocaleString("en-IN")}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No loan records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </DialogContent>

      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoanDetailsDialog;